import { userStore } from '@tools/ui-stores';

export function usePermissions() {
  const isToolsAdmin = userStore.hasTeamRole({
    teamName: 'Tools',
    roleName: 'Admin'
  });

  const isReconciliationAdmin = userStore.hasTeamRole({
    teamName: 'Reconciliation',
    roleName: 'Admin'
  });

  const isReconciliationAnalyst = userStore.hasTeamRole({
    teamName: 'Reconciliation',
    roleName: 'Analyst'
  });

  return {
    isAdmin: isReconciliationAdmin,
    isAnalyst: isReconciliationAdmin || isReconciliationAnalyst,
    isToolsAdmin
  };
}
